import { errors } from '@yola/ws-sdk';
import errorModule from 'src/js/modules/error';

const { REQUIRED_COOKIES_ARE_DELETED } = errorModule.constants;

const onCookieDelete = () => {
  errors.operations.catchError(new Error(REQUIRED_COOKIES_ARE_DELETED));
};

export default onCookieDelete;
